import useProductStore from '~/stores/useProductStore';
import usePageData from '~/stores/usePageData';
import type { ProductType } from '~~/server/pageData/productType';

export function useProductType(): ProductType {
  const productStore = useProductStore();
  const pageData = usePageData().pageData;

  const product = productStore.product;
  const productId = product.id;
  return (
    pageData.productType[productId] || {
      isGiftCard: false,
      isMaster: false,
      isGiftWithPurchase: false,
      isUnavailable: false,
      isShopTheSet: false,
      isLatchKey: false,
      isConsolidatedMaster: false,
      isConsolidatedStandard: false,
      isConsolidatedPage: false,
      isConsolidatedLatchKey: false,
      type: 'standard',
      pageLevelFeatureFlags: {},
    }
  );
}

export default useProductType;
